/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import style from '../styles/videoPreview.css';

const VideoPreview = ({
  className,
  propsStyle
}) => {
  const videoStyle = propsStyle;
  const videoClassName = className || style.video;

  return (
    <video
      id="videoSelectPreview"
      style={videoStyle}
      className={videoClassName}
      muted
      autoPlay
      playsInline
    />
  );
};

VideoPreview.propTypes = {
  className: PropTypes.string,
  propsStyle: PropTypes.object
};

export default VideoPreview;